export enum AxiosInstanceEnum {
  axiosInstanceV3 = 'axiosInstanceV3',
  axiosInstanceV4 = 'axiosInstanceV4',
}
